module.exports = __webpack_public_path__ + "static/media/schedulesIcon.bf61dedf.svg";